import "./global.js";

// แยกสิทธิ์เข้าใช้งาน 2 ระบบ — งานนิติบุคคล (เฟส 2) กับ งานขาย
//
// ★ ดูจากคีย์สิทธิ์ใน role.permissions เท่านั้น (กลุ่มเดียวกับหน้า /role: global.role_group)
//   super_user ก็ต้องมีคีย์ของฝั่งนั้นถึงจะเห็นฝั่งนั้น — ไม่ได้ดูแค่ user_type
// ★ ข้อยกเว้นเดียว: super_user ที่ไม่มีคีย์ของทั้งสองฝั่งเลย → เห็นทั้งสองฝั่ง (กันล็อกตัวเองออกจนใช้งานไม่ได้)
//   คนอื่นที่ไม่มีคีย์เลย → ไม่เห็นฝั่งไหน
// ★ ลูกบ้าน (customer) ไม่เกี่ยวกับการแยกนี้ — ใช้ flow เดิม

// หน้าฝั่งงานขาย — path อื่นที่ไม่ใช่ /console, /login, /doc/* ถือเป็นฝั่งนิติบุคคล
export const SALE_PATHS = [
  "/sale-dashboard",
  "/sale-inquiries",
  "/sale-page-contents",
  "/sale-project-settings",
  "/project-room-all",
  "/project-room-edit",
  "/sale-listing-logs",
];

const groupMenus = (label) =>
  (global.role_group || []).find((g) => g.label === label)?.menus || [];

const isCustomer = (p) => {
  if (!p) return false;
  if (p.user_type) return p.user_type === "customer";
  return !!p.customer_id && !p.user_id;
};

const hasAny = (permissions, menus) =>
  permissions.some((perm) => menus.includes(String(perm).split(".")[0]));

// คืน { legal, sale } ว่าเห็นฝั่งไหนได้บ้าง
export const getAccessSides = (profile) => {
  if (!profile || isCustomer(profile)) return { legal: true, sale: true };
  const permissions = profile?.role?.permissions;
  // ยังไม่มีข้อมูลสิทธิ์ (โปรไฟล์เก่า/ยังไม่ได้ดึง) = ยังไม่ซ่อน backend ตรวจซ้ำอยู่แล้ว
  if (!Array.isArray(permissions)) return { legal: true, sale: true };
  const legal = hasAny(permissions, groupMenus("งานนิติบุคคล"));
  const sale = hasAny(permissions, groupMenus("งานขาย"));
  if (!legal && !sale && profile.user_type === "super_user") return { legal: true, sale: true };
  return { legal, sale };
};

// path นี้เป็นของฝั่งไหน — "sale" | "legal" | null (ไม่เกี่ยวกับการแยก)
export const sideOfPath = (path) => {
  const p = String(path || "").split("?")[0];
  if (!p || p === "/" || p === "/console" || p === "/login" || p === "/template" || p.startsWith("/doc/")) return null;
  return SALE_PATHS.includes(p) ? "sale" : "legal";
};

export const canAccessPath = (path, profile) => {
  const side = sideOfPath(path);
  if (!side) return true;
  return getAccessSides(profile)[side];
};
